import { Container, Stack } from '@mui/material';
import React from 'react';

import { Page } from '../../../../components';
import HeaderBreadcrumbs from '../../../../components/header-breadcrumbs';
import { AlertList } from '../../../../components/lists/alerts-list';
import { useGenericQuery } from '../../../../services/react-query/generic.query';

export const AlertListScreen: React.FC = () => {
    const {
        data: retentionDays, 
        isLoading: retentionDaysLoading,
    } = useGenericQuery<number>('getAletsRetentionDays', 'alerts/getRetentionDays');

    return (
        <Page title="POM Admin - Alerts">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="Alerts"
                        links={[
                            {
                                name: !retentionDaysLoading ?
                                    `Your organizations retention policy for Alerts is ${retentionDays} days. After which, alerts will be removed.` :
                                    'Loading retention policy...',
                                href: '/alerts'
                            },
                        ]}
                        activeLast={false}
                    />
                </Stack>
                <AlertList />
            </Container>
        </Page>
    )
}